<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.press.meta.title'),
  description: t('pages.index.meta.description'),
})

// TODO: I don't know how to get both calls as lazy.

const activeSectionNid = ref<number>(0)

// TODO should get all pages
const pressesRepository = createPressesRepository()

const { data: pressSections } = await useAsyncData(() =>
  pressesRepository.getAllSections({
    sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
  })
)

if (!pressSections.value) {
  throw createError('Not found')
} else {
  activeSectionNid.value = pressSections.value.items[0].nid
}

const activeSection = computed(() => {
  return pressSections.value?.items.find(
    (section) => section.nid === activeSectionNid.value
  )
})

const { data: presses } = await useLazyAsyncData(
  `press-list-${activeSectionNid.value}`,
  () =>
    pressesRepository.getAllPresses({
      filter: APIFilters.makeFilter([
        {
          [APIFilterOP.EQUALS]: {
            'section.nid': activeSection.value?.nid,
          },
        },
      ]),
      sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
    }),
  {
    watch: [activeSection],
  }
)
</script>

<template>
  <main>
    <UiBanner
      :title="$t('pages.press.label')"
      :description="$t('pages.press.description')"
    />
    <PressTabs
      v-model="activeSectionNid"
      :sections="pressSections?.items ?? []"
      @update:model-value="(nid: number) => (activeSectionNid = nid)"
    />
    <div class="container grid grid-cols-1 gap-4 py-16">
      <PressCard
        v-for="press in presses?.items ?? []"
        :key="press.nid"
        :press-nid="press.nid"
      />
    </div>
  </main>
</template>

<style scoped></style>
